var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientsNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662542366271,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 46842,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M927.5 886.5c-4.8-168.9-136.3-308.9-295.6-308.9H394.2c-162.4 0-289.9 139.7-295.7 318.5 0 22.4 17.4 39.1 40.6 39.1h746c13.8 0 25.6-7.3 32.3-17.9 1.9-2.5 3.7-5.1 5.2-7.9 3.7-7 5.2-15 4.9-22.9zM735.3 740.2L642 822.4c-29.1 25.7-75.7 25.7-110.7 5.1l-81.6-51.3L344.8 843c-10.7 7.1-17.6 9.3-23.3 10.3-10.7 1.8-22.4-0.6-35-15.4-11.7-15.4-11.7-36 5.8-51.4l99.1-66.8c29.1-20.5 69.9-20.5 99.1 0l81.6 51.4L677 688.9c17.5-15.4 40.8-15.4 58.3 0 17.4 15.4 17.4 35.9 0 51.3zM387.8 501.8c77.5 39.4 173 39.4 250.5 0s125.3-112.3 125.3-191.2c0-122-112.2-220.8-250.5-220.8-138.4 0-250.5 98.9-250.5 220.8-0.1 78.9 47.7 151.8 125.2 191.2z",
    fill: "#ffffff",
    "p-id": 46843
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsNumber);
export default __webpack_public_path__ + "static/media/patientsNumber.de5de48c.svg";
export { ForwardRef as ReactComponent };